function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import classnames from 'classnames';
import { setGlobalCssVariables } from '../../utils/css';
import { convertChildrenToRows, findParentElement } from './utils';
import Row from './row';
import HeaderRow from './header-row';
import RowGroup from './row-group';
import ComparisonViewContext from './comparison-view-context';
var EMPTY_DATA_SOURCE = [];
var DEFAULT_CARD_GUTTER = 12;
// tslint:disable-next-line:function-name
function ComparisonView(props) {
  var _props$dataSource, _props$type;
  var className = props.className,
    loading = props.loading,
    gutter = props.gutter,
    colKey = props.colKey,
    colClassName = props.colClassName,
    headerRow = props.headerRow,
    rows = props.rows,
    children = props.children;
  var mergedRows = React.useMemo(function () {
    var resolvedRows = rows !== null && rows !== void 0 ? rows : convertChildrenToRows(children);
    var resolvedHeaderRow = resolvedRows.find(function (row) {
      return row.__isHeaderRow;
    });

    // ensure header row
    if (headerRow) {
      if (!resolvedHeaderRow) {
        resolvedRows.unshift(_objectSpread(_objectSpread({}, headerRow), {}, {
          __isHeaderRow: true
        }));
      } else {
        throw new Error('Multiple HeaderRow definitions detected');
      }
    }
    resolvedHeaderRow = resolvedRows.find(function (row) {
      return row.__isHeaderRow;
    });
    if (!resolvedHeaderRow) {
      throw new Error('Missing HeaderRow definition');
    }

    // mark footer row
    resolvedRows[resolvedRows.length - 1].__isFooterRow = true;
    return resolvedRows;
  }, [children, rows, headerRow]);
  var rawData = (_props$dataSource = props.dataSource) !== null && _props$dataSource !== void 0 ? _props$dataSource : EMPTY_DATA_SOURCE;
  var childrenRowName = 'children';

  // ============================ RowKey ============================
  var getColKey = React.useMemo(function () {
    if (typeof colKey === 'function') {
      return colKey;
    }
    return function (record) {
      return record === null || record === void 0 ? void 0 : record[colKey];
    };
  }, [colKey]);

  // ============================ ColClassName ============================
  var getColClassName = React.useMemo(function () {
    if (typeof colClassName === 'function') {
      return colClassName;
    }
    return function () {
      return colClassName;
    };
  }, [colClassName]);
  var viewType = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'card';

  // ============================ Gutter ============================
  React.useEffect(function () {
    var resolvedGutter = gutter;
    if (!Number.isFinite(resolvedGutter) && viewType === 'card') {
      resolvedGutter = DEFAULT_CARD_GUTTER;
    }
    if (Number.isFinite(resolvedGutter)) {
      setGlobalCssVariables('comparison-view-gutter', "".concat(resolvedGutter, "px"));
    }
  }, [gutter, viewType]);

  // ============================ Hovering Status Handlers ============================
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentHoveringColIndex = _React$useState2[0],
    setCurrentHoveringColIndex = _React$useState2[1];
  var handleColMouseEnter = React.useCallback(function (ev, record, recordIndex) {
    var _ev$nativeEvent, _event$fromElement$da, _event$fromElement, _event$toElement$data, _event$toElement, _getColKey;
    var event = (_ev$nativeEvent = ev.nativeEvent) !== null && _ev$nativeEvent !== void 0 ? _ev$nativeEvent : ev;
    var fromElData = (_event$fromElement$da = (_event$fromElement = event.fromElement) === null || _event$fromElement === void 0 ? void 0 : _event$fromElement.dataset) !== null && _event$fromElement$da !== void 0 ? _event$fromElement$da : {};
    var toElData = (_event$toElement$data = (_event$toElement = event.toElement) === null || _event$toElement === void 0 ? void 0 : _event$toElement.dataset) !== null && _event$toElement$data !== void 0 ? _event$toElement$data : {};
    var recordColKey = (_getColKey = getColKey(record, recordIndex)) !== null && _getColKey !== void 0 ? _getColKey : recordIndex;
    var parentMatch = findParentElement(event.toElement, function (el) {
      var _el$dataset;
      return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.colKey) === recordColKey.toString();
    });
    var newColIndex = currentHoveringColIndex !== recordIndex;
    if ((parentMatch || fromElData.colKey !== toElData.colKey) && newColIndex) {
      var _props$onColMouseEnte;
      setCurrentHoveringColIndex(recordIndex);
      (_props$onColMouseEnte = props.onColMouseEnter) === null || _props$onColMouseEnte === void 0 ? void 0 : _props$onColMouseEnte.call(props, ev, record, recordIndex);
    }
  }, [currentHoveringColIndex]);
  var handleColMouseLeave = React.useCallback(function (ev, record, recordIndex) {
    var _ev$nativeEvent2, _event$fromElement$da2, _event$fromElement2, _event$toElement$data2, _event$toElement2;
    var event = (_ev$nativeEvent2 = ev.nativeEvent) !== null && _ev$nativeEvent2 !== void 0 ? _ev$nativeEvent2 : ev;
    var fromElData = (_event$fromElement$da2 = (_event$fromElement2 = event.fromElement) === null || _event$fromElement2 === void 0 ? void 0 : _event$fromElement2.dataset) !== null && _event$fromElement$da2 !== void 0 ? _event$fromElement$da2 : {};
    var toElData = (_event$toElement$data2 = (_event$toElement2 = event.toElement) === null || _event$toElement2 === void 0 ? void 0 : _event$toElement2.dataset) !== null && _event$toElement$data2 !== void 0 ? _event$toElement$data2 : {};
    var noColKeys = toElData.colKey === undefined && fromElData.colKey === undefined;
    if (noColKeys || toElData.colKey !== fromElData.colKey) {
      var parentMatch = findParentElement(event.toElement, function (el) {
        var _el$dataset2;
        return ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.colKey) === fromElData.colKey;
      });
      if (noColKeys || !parentMatch) {
        var _props$onColMouseLeav;
        setCurrentHoveringColIndex(undefined);
        (_props$onColMouseLeav = props.onColMouseLeave) === null || _props$onColMouseLeav === void 0 ? void 0 : _props$onColMouseLeav.call(props, ev, record, recordIndex);
      }
    }
  }, [currentHoveringColIndex]);

  // ============================ Context ============================
  var contextValue = React.useMemo(function () {
    return {
      currentHoveringColIndex: currentHoveringColIndex
    };
  }, [currentHoveringColIndex]);
  return /*#__PURE__*/React.createElement(ComparisonViewContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('comparison-view', className, "view-type-".concat(viewType), _defineProperty({
      loading: loading
    }, 'show-gutter', !!gutter))
  }, mergedRows.map(function (row, index) {
    return /*#__PURE__*/React.createElement(RowGroup, {
      key: index,
      index: index,
      getColKey: getColKey,
      getColClassName: getColClassName,
      childrenRowName: childrenRowName,
      row: row,
      dataSource: rawData,
      onColMouseEnter: handleColMouseEnter,
      onColMouseLeave: handleColMouseLeave
    });
  })));
}
ComparisonView.defaultProps = {
  rowKey: 'key'
};
ComparisonView.Row = Row;
ComparisonView.HeaderRow = HeaderRow;
export default ComparisonView;